import React from 'react'

//STYLES
import './TaskLink.css'
import { useNavigate } from 'react-router-dom'

//IMGS
import check from '../../assets/icons/check-green.svg'
import circle from '../../assets/icons/circle.svg'

//COMPONENTS
import Button from '../ui/Button'

export default function TaskLink( { task, setTasks } ) {
    const nav = useNavigate()

    const navToDetails = () => {
        nav('/bar/task/' + task.id)
    }

    const switchCompleted = (e) => {
        e.preventDefault()
        setTasks((prev) => {
            return prev.map( (t) => {
                if (t.id === task.id) {
                    const currentStatus = t.completed
                    return{...t, completed: !currentStatus}
                } else {
                    return t
                }
            } )
        })
    }

    return (
        <>
        { task && (
            <div className={`task-link-container shadowed ${task.completed ? 'completed' : ''}`}  >
                <div className="check-box" onClick={switchCompleted}>
                        <img src={circle} alt="circle icon" className="back" />
                        <img src={check} alt="check icon" className="front" />
                </div>
                <span className="task-name">{ task.title }</span>
                <span className="info-btn">
                    { (task.contentBlocks && task.contentBlocks.length > 0) && <Button
                        icon="INFO"
                        isInverted
                        clickFunction={navToDetails}
                    />}
                </span>
            </div>
        )}
        </>
    )
}
